import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const entityDependencyContentExtension: any = EntityContentBlueprint.make({
    name: 'dependencies',
    params: {
        path: '/dependencies',
        title: 'Dependencies',
        loader: async () =>
            import('./EntityDependencyContent').then((m) =>
                <m.EntityDependencyContent />
            ),
    },
});